// import React, { useState } from "react";
// import backgroundimage from "../../assets/images/whitebackground.jpg";
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   Button,
//   Grid,
//   Paper,
//   Stack,
//   Divider,
// } from "@mui/material";

// const VideoLeadSection = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//   });

//   const phoneNumber = "7762012673";

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleWhatsApp = () => {
//     const message = `Hello, I want to know more about your services.

// Name: ${formData.name}
// Email: ${formData.email}
// Mobile: ${formData.mobile}`;

//     const url = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
//       message
//     )}`;

//     window.open(url, "_blank");
//   };

//   const handleCall = () => {
//     window.location.href = `tel:+91${phoneNumber}`;
//   };

//   return (
//     <Box
//       sx={{
//         py: { xs: 5, md: 10 },
//         backgroundImage: `url(${backgroundimage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundAttachment: "fixed",
//       }}
//     >
//       <Container maxWidth={false}>
//         <Box sx={{ maxWidth: "1200px", mx: "auto", mt: 6 }}>
          
//           {/* ================= VIDEO CARD ================= */}
//           <Paper
//             elevation={6}
//             sx={{
//               borderRadius: 4,
//               overflow: "hidden",
//               mb: { xs: 3, md: 5 }, // ✅ gap added
//             }}
//           >
//             <Box
//               sx={{
//                 position: "relative",
//                 width: "100%",
//                 pt: { xs: "56.25%", md: "42%" },
//               }}
//             >
//               <iframe
//                 src="https://www.youtube.com/embed/1oTuMPIwHmk?autoplay=1&mute=0&controls=1&loop=1&playlist=1oTuMPIwHmk"
//                 title="IT Services Video"
//                 allow="autoplay; encrypted-media"
//                 allowFullScreen
//                 style={{
//                   position: "absolute",
//                   inset: 0,
//                   width: "100%",
//                   height: "100%",
//                   border: "none",
//                 }}
//               />
//             </Box>
//           </Paper>

//           {/* ================= INFO BAR ================= */}
//           <Paper
//             elevation={0}
//             sx={{
//               mb: { xs: 3, md: 4 },
//               borderRadius: 3,
//               background: "linear-gradient(135deg, #2d4a78, #15807c)",
//               color: "#fff",
//               textAlign: "center",
//               py: 2.5,
//               px: 2,
//             }}
//           >
//             <Typography
//               variant="h5"
//               fontWeight={700}
//               sx={{ fontSize: { xs: "20px", md: "26px" } }}
//             >
//               🚀 Grow Your IT Business Faster
//             </Typography>

//             <Typography sx={{ opacity: 0.95 }}>
//               Fill details and connect instantly with our experts
//             </Typography>
//           </Paper>

//           {/* ================= FORM CARD ================= */}
//           <Paper
//             elevation={4}
//             sx={{
//               borderRadius: 4,
//               p: { xs: 3, md: 5 },
//               background: "rgba(255,255,255,0.97)",
//               backdropFilter: "blur(6px)",
//             }}
//           >
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   label="Full Name"
//                   name="name"
//                   size="medium"
//                   value={formData.name}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   label="Email Address"
//                   name="email"
//                   type="email"
//                   size="medium"
//                   value={formData.email}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   label="Mobile Number"
//                   name="mobile"
//                   size="medium"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Divider sx={{ my: 1.5 }} />
//               </Grid>

//               {/* PREMIUM SMALL BUTTONS */}
//               <Grid item xs={12}>
//                 <Stack
//                   direction={{ xs: "column", sm: "row" }}
//                   spacing={2}
//                   justifyContent="center"
//                   alignItems="center"
//                 >
//                   <Button
//                     variant="contained"
//                     size="medium"
//                     onClick={handleWhatsApp}
//                     sx={{
//                       px: 4,
//                       py: 1,
//                       fontWeight: 600,
//                       borderRadius: "12px",
//                       textTransform: "none",
//                       fontSize: "14px",
//                       background:
//                         "linear-gradient(45deg,#25D366,#128C7E)",
//                       boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//                     }}
//                   >
//                     💬 Submit
//                   </Button>

//                   <Button
//                     variant="contained"
//                     size="medium"
//                     onClick={handleCall}
//                     sx={{
//                       px: 4,
//                       py: 1,
//                       fontWeight: 600,
//                       borderRadius: "12px",
//                       textTransform: "none",
//                       fontSize: "14px",
//                       background:
//                         "linear-gradient(45deg,#ff4b2b,#ff416c)",
//                       boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//                     }}
//                   >
//                     📞 Book a Call
//                   </Button>
//                 </Stack>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default VideoLeadSection;



import React, { useState } from "react";
import backgroundimage from "../../assets/images/whitebackground.jpg";
import contactImage from "../../assets/images/any.png"; // Add your image here
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Stack,
  Divider,
  TextareaAutosize,
} from "@mui/material";

const VideoLeadSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const phoneNumber = "7762012673";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsApp = () => {
    const message = `Hello, I want to know more about your services.

Name: ${formData.name}
Email: ${formData.email}
Mobile: ${formData.mobile}
Message: ${formData.message}`;

    const url = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
  };

  const handleCall = () => {
    window.location.href = `tel:+91${phoneNumber}`;
  };

  return (
    <Box
      sx={{
        py: { xs: 5, md: 10 },
        backgroundImage: `url(${backgroundimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: "1200px", mx: "auto", mt: { xs: 2, md: 6 } }}>
          
          {/* ================= VIDEO CARD ================= */}
          {/* <Paper
            elevation={6}
            sx={{
              borderRadius: 4,
              overflow: "hidden",
              mb: { xs: 3, md: 5 },
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                pt: { xs: "56.25%", md: "42%" },
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/1oTuMPIwHmk?autoplay=1&mute=0&controls=1&loop=1&playlist=1oTuMPIwHmk"
                title="IT Services Video"
                allow="autoplay; encrypted-media"
                allowFullScreen
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
            </Box>
          </Paper> */}

          {/* ================= INFO BAR ================= */}
          <Paper
            elevation={0}
            sx={{
              mb: { xs: 3, md: 4 },
              borderRadius: 3,
              background: "linear-gradient(135deg, #2d4a78, #15807c)",
              color: "#fff",
              textAlign: "center",
              py: 2.5,
              px: 2,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ fontSize: { xs: "20px", md: "26px" } }}
            >
              🚀 Grow Your IT Business Faster
            </Typography>

            <Typography sx={{ opacity: 0.95 }}>
              Fill details and connect instantly with our experts
            </Typography>
          </Paper>

          {/* ================= IMAGE + FORM SECTION ================= */}
          <Grid container spacing={3}>
            {/* LEFT SIDE - IMAGE */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={4}
                sx={{
                  borderRadius: 4,
                  overflow: "hidden",
                  height: "100%",
                  minHeight: { xs: "250px", md: "450px" },
                  position: "relative",
                  backgroundImage: `url(${contactImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                {/* Overlay with text */}
                <Box
                  sx={{
                    width: "100%",
                    background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                    color: "white",
                    p: 3,
                  }}
                >
                  <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                    Get In Touch
                  </Typography>
                  <Typography variant="body1">
                    We're here to help you grow your business
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* RIGHT SIDE - FORM */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={4}
                sx={{
                  borderRadius: 4,
                  p: { xs: 3, md: 4 },
                  background: "rgba(255,255,255,0.97)",
                  backdropFilter: "blur(6px)",
                  height: "100%",
                }}
              >
                <Typography variant="h5" fontWeight="600" sx={{ mb: 3 }}>
                  Send Us a Message
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name *"
                      name="name"
                      size="medium"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email Address *"
                      name="email"
                      type="email"
                      size="medium"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Mobile Number *"
                      name="mobile"
                      size="medium"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Your Message"
                      name="message"
                      multiline
                      rows={4}
                      size="medium"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your requirements..."
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 1.5 }} />
                  </Grid>

                  {/* BUTTONS */}
                  <Grid item xs={12}>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Button
                        variant="contained"
                        size="large"
                        onClick={handleWhatsApp}
                        fullWidth
                        sx={{
                          py: 1.5,
                          fontWeight: 600,
                          borderRadius: "12px",
                          textTransform: "none",
                          fontSize: "16px",
                          background:
                            "linear-gradient(45deg,#25D366,#128C7E)",
                          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                          '&:hover': {
                            background: "linear-gradient(45deg,#128C7E,#25D366)",
                          }
                        }}
                      >
                        💬 Send via WhatsApp
                      </Button>

                      <Button
                        variant="contained"
                        size="large"
                        onClick={handleCall}
                        fullWidth
                        sx={{
                          py: 1.5,
                          fontWeight: 600,
                          borderRadius: "12px",
                          textTransform: "none",
                          fontSize: "16px",
                          background:
                            "linear-gradient(45deg,#ff4b2b,#ff416c)",
                          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                          '&:hover': {
                            background: "linear-gradient(45deg,#ff416c,#ff4b2b)",
                          }
                        }}
                      >
                        📞 Book a Free Call
                      </Button>
                    </Stack>
                  </Grid>

                  {/* Contact info */}
                  <Grid item xs={12}>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        Or call us directly: <strong>+91 {phoneNumber}</strong>
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          {/* Optional bottom bar */}
          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              ⏱️ Average response time: &lt; 5 minutes
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default VideoLeadSection;